// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 1.0
// updated  : 2026-06-19
// protected: NO
// =============================================================================
// Panel stok real-time dari ledger view (/stock/summary). Sumber kebenaran: backend.
import React, { useEffect, useState, useCallback } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Boxes, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useV2Auth } from "@/v2/V2AuthContext";

export const StockPanel = ({ location, title }) => {
  const { api } = useV2Auth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = useCallback(async () => {
    if (!location) return;
    setLoading(true);
    try {
      const r = await api(`/api/v2/stock/summary?location=${location}`);
      setRows(r.ok ? await r.json() : []);
    } finally { setLoading(false); }
  }, [api, location]);
  useEffect(() => { load(); }, [load]);

  return (
    <Card className="p-4 rounded-2xl" data-testid="v2-stock-panel">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2"><Boxes className="w-4 h-4 text-primary" /><h4 className="font-semibold text-sm">{title || "Stok tersedia"} · {location}</h4></div>
        <Button size="icon" variant="ghost" onClick={load} data-testid="v2-stock-refresh"><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <div className="max-h-64 overflow-y-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Merchandize</TableHead><TableHead>Size</TableHead>
            <TableHead className="text-right">Available</TableHead><TableHead className="text-right">Reserved</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-4 text-sm">{loading ? "Memuat..." : "Tidak ada stok."}</TableCell></TableRow>}
            {rows.map((r, i) => (
              <TableRow key={i} data-testid="v2-stock-row">
                <TableCell className="text-sm">{r.product_name || "-"}</TableCell>
                <TableCell>{r.size || "-"}</TableCell>
                <TableCell className="text-right tabular-nums font-medium">{r.available}</TableCell>
                <TableCell className="text-right tabular-nums"><Badge variant="outline">{r.reserved}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};
